import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import SectionFields from "../tabs/common/Section/SectionFields";
import type { AssessmentReport } from "../../types";
import type { Field } from "../tabs/types";

export function ReadOnlyAssessmentReportContainer({
  assessmentReport,
}: {
  assessmentReport?: AssessmentReport;
}) {
  const fields: Array<Field> = [
    {
      name: "Developer Information",
      type: "text",
      richText: true,
      index: 0,
      value: assessmentReport?.developerInfo,
    },
    {
      name: "SDG Information",
      type: "text",
      richText: true,
      index: 1,
      value: assessmentReport?.sdgInfo,
    },
    {
      name: "Monitoring Information",
      type: "text",
      richText: true,
      index: 2,
      value: assessmentReport?.monitoringInfo,
    },
    {
      name: "Location Information",
      type: "text",
      richText: true,
      index: 3,
      value: assessmentReport?.locationInfo,
    },
  ];

  return (
    <Box data-testid="read-only-assessment-report-container">
      <SectionCollapsible label="Assessment Report">
        <SectionFields
          fields={fields}
          columns={1}
          fieldIdPrefix="read-only-assessment-report-values"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyAssessmentReportContainer;
